enum FlowMode {
    _3D2D,          // BIM
    _2D3D,          // PDF simple
    _2D3DAdvanced   // PDF superposé
}

export default FlowMode;